
export const aboutData = {
    title: "Who I am",
    description1: "My name is Rohit Kumar. I'm a Full-stack Web Developer.",
    description2: "I have been passionate about new technologies and computers since childhood. That's why I chose Engineering. But due to lack of proper guidance, I chose Electrical engineering. In college, I realized it was not for me.I remember the first time I wrote a code using the C language, words will fail to express how I felt in that moment. It was the turning point in my life and that's how I chose Masai school to pursue full-stack web development.",
    image: 1
}